import { getInstance } from "./authWrapper";
import myApp from "../main";

export const authGuard = (to, from, next) => {
  const authService = getInstance();

  const fn = () => {
    if (authService.isAuthenticated) {
      if (to.params.tenantId) {
        if (to.params.tenantId !== sessionStorage.getItem("tenantId")) {
          return next();
        } else {
          if (!myApp.$security.checkUserAccess(to.meta.authorizationKey))
            return next({ name: "Forbidden" });
          return next();
        }
      } else {
        if (!myApp.$security.checkUserAccess(to.meta.authorizationKey))
          return next({ name: "Forbidden" });
        return next();
      }
    }
    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
    return next(false);
  };

  if (!authService.loading) {
    return fn();
  }

  authService.$watch("loading", (loading) => {
    if (loading === false) {
      return fn();
    }

    return next(false);
  });
};
